
export const USERS_COLUMNS = [
    "Profile",
    // "Email",
    "Name",
    "Contact No",
    "Role",
    "Plan",
    "Designation",
    // "JoinedDate",
    // "Firm Name",
    // "Gender",
    // "Dob",
    // "Address"
];